import 'reflect-metadata';
import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { EmployeeModel } from './employee.model';
import { getSchema } from '@awslabs-community-fork/dynamodb-data-mapper';
import { OrganizationPermissionInterface } from '../interfaces/organization-permission.interface';
import { Expose } from 'class-transformer';
import { LicenseModel } from './license.model';
import { property } from '@pristine-ts/metadata';
import { array } from '@pristine-ts/data-mapping-common';


@dynamicTableName('ORGANIZATION_TABLE_NAME')
export class OrganizationModel {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  name: string;
  @attribute({
    type: 'List',
    memberType: {
      type: 'Document',
      members: getSchema(EmployeeModel.prototype),
      valueConstructor: EmployeeModel,
    },
  })
  @array(EmployeeModel)
  employees: EmployeeModel[] = [];
  @attribute()
  @property()
  permissions: OrganizationPermissionInterface;
  @attribute()
  @property()
  organizationQuotaId: string;
  @attribute()
  @property()
  paymentMethodId: string;
  @attribute()
  @property()
  usageId: string;
  @attribute()
  @property()
  subscriptionId: string;
  @attribute()
  @property()
  stripeCustomerId: string;
  @Expose()
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
  @attribute()
  @property({ nullable: true })
  activeLicense?: LicenseModel;
  @attribute()
  @property()
  stripeSubscriptionId?: string;
}
